import React from 'react';
import { useTranslation } from 'react-i18next';
export default function NotFound(){
  const { t } = useTranslation();
  return (
    <main className="container" style={{ padding:'16px 0' }}>
      <h2>{t('notFound')}</h2><p>{t('placeholder')}</p>
    </main>
  );
}
